import { toast } from "react-toastify";

export const errorHandler = (err: any): { data?: any; error: any; } => {
	const error = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Une erreur est survenue';
	toast.error(error);
	return { error };
}

// Merges the financial fields returned by the backend after a transaction
// is added/canceled/imputed into a locally held invoice, so payment modals
// can reflect the new balance immediately without a full refetch.
export const mergeInvoiceFields = (base: any, updated: any) => {
	if (!updated) return base;
	return {
		...(base ?? {}),
		totalTTC: updated.totalTTC,
		amountPaid: updated.amountPaid,
		leftToPay: updated.leftToPay,
		status: updated.status,
		transactions: updated.transactions,
	};
}
